import React from "react";
import { NUMERIC_SX } from "../theme";

export const Num: React.FC<{ children?: React.ReactNode }> = ({ children }) => (
  <span style={{ fontFamily: NUMERIC_SX.fontFamily, fontVariantNumeric: NUMERIC_SX.fontVariantNumeric }}>{children}</span>
);
